import InlineEdit from './InlineEdit';

export default InlineEdit;
